<template>
  <div>
    <h5 class="mb-4">반려문서함</h5>
    <search-nav size="mobile" align="justify-end" @handleSearch="handleSearch">
      <search-nav-item-keyword class="w-full" size="mobile" label="검색" v-model="nav.keyword"></search-nav-item-keyword>
    </search-nav>
    <div class="flex mb-4" style="justify-content: flex-end;">
    </div>
    <div class="flex " style="justify-content: flex-start;">
      <h5 class="mb-4" style="font-size:1rem;">결재문서 목록</h5>
    </div>
    <div style="margin:0 -1.2rem;">
      <vs-table
        style="border:1px solid #cdcdcd; border-radius: 0;"
        stripe
        ref="table"
        :sst="true"
        :max-items="table.perPage"
        :data="table.list"
        noDataText="결재문서가 없습니다."
        @selected="handleItemClickDetail">

        <template slot="thead">
          <vs-th style="min-width:130px;"><span class="w-full text-center">No.</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">게시판</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">제목</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">상세</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">작성일</span></vs-th>

        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="text-center">{{ tr.post_id }}</vs-td>
            <vs-td class="text-center">{{ getBoardTitle(tr) }}</vs-td>
            <vs-td class="text-center">{{ getPostTitle(tr) }}</vs-td>
            <vs-td class="text-center">{{ tr.document_status.name }}</vs-td>
            <vs-td class="text-center">{{ tr.created_at }}</vs-td>
          </vs-tr>

        </template>
      </vs-table>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="(lastPage) ? lastPage : 1"
            v-model="currentPage" @change="handleChangePage"></k-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchNav from '@/views/components/nav/SearchNav'
import SearchNavItemDate from '@/views/components/nav/SearchNavItemDate'
import SearchNavItemKeyword from '@/views/components/nav/SearchNavItemKeyword'
import SearchNavItemSelect from '@/views/components/nav/SearchNavItemSelect'
import KPagination from '@/views/components/kPagination/kPagination'

export default {
  name: 'MobileApprovalReject',
  components: {
    KPagination,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    SearchNavItemDate,
    SearchNav
  },
  computed: {
    rootPath () {
      const paths = this.$route.path.split('/')
      return `/${paths[1]}/${paths[2]}/${paths[3]}`
    }
  },
  data () {
    return {
      // 검색 네비게이션
      nav: {
        date: ['', ''],
        keyword: '',
        type: '',
        typeList: []
      },

      currentPage: 1,
      lastPage: 1,
      table: {
        list: [],
        perPage: 7,
        keyword: ''
      }
    }
  },
  created () {
    //this.loadPostList()
  },

  methods: {

    async loadPostList () {
      const projectId = this.$route.params.proj_id
      const boardSlug = ''
      const page = this.currentPage
      const perPage = this.table.perPage
      await this.$store.dispatch('approval/LOAD_REJECT_LIST', {page, perPage, boardSlug, projectId})
      this.table.list = this.$store.state.approval.list

      const listInfo = this.$store.state.approval.postListInfo
      this.currentPage = listInfo.current_page
      this.lastPage = listInfo.last_page

    },

    handleSearch () {
      this.loadPostList()
    },

    getPreview (data) {
      if (data.post.preview) {
        const preview = JSON.parse(data.post.preview)
        return preview
      }
    },

    getBoardTitle (data) {
      if (data.post && data.post.board) {
        return data.post.board.board_title
      }

      return ''
    },

    getPostTitle (data) {
      if (data.post) {
        return data.post.post_title
      }

      return ''
    },

    handleChangePage (page) {
      this.currentPage = page
      this.loadPostList()
    },

    handleItemClickDetail (data) {
      const projectId = data.post.project_id
      const boardId = data.post.board_id
      const postId = data.post.id
      this.movePost(projectId, boardId, postId)
    },


    movePost (projectId, boardId, postId) {

// 모바일 페이지가 없는 결재 문서들
      /* 안전·보건예산 현황 */
      if (boardId === 3) { this.$router.push({path: `/project/${projectId}/report/${postId}`}); return }
      /* 최초 위험성평가 */
      if (boardId === 6) { this.$router.push({path: `/project/${projectId}/risk/assessment/first/${postId}`}); return }
      /* 위험성평가협의회 */
      if (boardId === 8) { this.$router.push({path: `/project/${projectId}/risk/conference/warning/${postId}`}); return }
      /* 산업안전보건위원회 */
      if (boardId === 9) { this.$router.push({path: `/project/${projectId}/risk/conference/safety/${postId}`}); return }
      /* 작업허가서 */
      if (boardId === 10) { this.$router.push({path: `/project/${projectId}/risk/permit/work/${postId}`}); return }
      /* 작업허가서(외부용) */
      if (boardId === 11) { this.$router.push({path: `/project/${projectId}/risk/permit/special/${postId}`}); return }
      /* 산업재해무재해 */
      if (boardId === 22) { this.$router.push({path: `/project/${projectId}/safety/accident/report/${postId}`}); return }
      /* 안전용품 현황 */
      if (boardId === 23) { this.$router.push({path: `/project/${projectId}/safety/supplies/${postId}`}); return }
      /* 환경지원 */
      if (boardId === 30) { this.$router.push({path: `/project/${projectId}/state/support/${postId}`}); return }
      /* 환경평가 */
      if (boardId === 31) { this.$router.push({path: `/project/${projectId}/state/evaluation/${postId}`}); return }
      /* 환경이슈보고 */
      if (boardId === 32) { this.$router.push({path: `/project/${projectId}/state/report/issue/${postId}`}); return }
      /* 환경사고보고 */
      if (boardId === 33) { this.$router.push({path: `/project/${projectId}/state/report/accident/${postId}`}); return }


// 모바일 페이지가 있는 결재 문서들
      /* 정기위험성평가 */
      if (boardId === 7) { this.$router.push({path: `${this.rootPath}/safety/${postId}/regular-assessment-update`}); return }
      /* 안전점검일지 */
      if (boardId === 13) { this.$router.push({path: `${this.rootPath}/safety/${postId}/daily-checklog-update`}); return }
      /* 합동점검일지 */
      if (boardId === 14) { this.$router.push({path: `${this.rootPath}/safety/${postId}/daily-checklogall-update`}); return }
      /* 장비점검계획 */
      if (boardId === 24) { this.$router.push({path: `${this.rootPath}/safety/${postId}/equipment-check-update`}); return }
      /* 환경일일점검 */
      if (boardId === 28) { this.$router.push({path: `${this.rootPath}/state/${postId}/daily-check-update`}); return }
      /* 환경월간점검 */
      if (boardId === 29) { this.$router.push({path: `${this.rootPath}/state/${postId}/monthly-check-update`}); return }
      /* HSE 교육관리 */
      if (boardId === 35) { this.$router.push({path: `${this.rootPath}/hse/${postId}/health-update`}); return }
      /* 안전요청 */
      if (boardId === 36) { this.$router.push({path: `${this.rootPath}/prevention/safety-request/${postId}`}); return }
      /* 환경요청 */
      if (boardId === 39) { this.$router.push({path: `${this.rootPath}/prevention/environment-request/${postId}`}); return }
      /* 보건요청 */
      if (boardId === 40) { this.$router.push({path: `${this.rootPath}/prevention/health-request/${postId}`}); return }


    },
  }
}
</script>

<style scoped>

</style>
